import React, { ReactElement } from 'react';
import Checkbox from './previewElements/Checkbox';
import MultipleSelection from './previewElements/MultipleSelection';
import TextInput from './previewElements/TextInput';
import Rating from './previewElements/Rating';
import DropDown from './previewElements/DropDown';
import Date from './previewElements/Date';
import Time from './previewElements/Time';
import MultiLineTextInput from './previewElements/MultiLineTextInput';
import TextBlock from './previewElements/TextBlock';
import SignatureInput from './previewElements/SignatureInput';
import { FormQuestionType } from '@televet/shared-types';

interface IQuestion {
  question: {
    index: number;
    type?: FormQuestionType;
    prompt: string;
    defaultValue?: boolean | null;
    options?: string[];
    minValue?: number;
    maxValue: number;
    isRequired: boolean;
  };
}
const Question = ({ question }: IQuestion): ReactElement => {
  const { index, type, prompt, defaultValue, options, minValue, maxValue, isRequired } = question;

  switch (type) {
    case FormQuestionType.Checkbox:
      return (
        <Checkbox
          index={index}
          prompt={prompt || ''}
          defaultValue={defaultValue || false}
          isRequired={isRequired || false}
        />
      );
    case FormQuestionType.MultipleSelection:
      return (
        <MultipleSelection
          index={index}
          prompt={prompt || ''}
          options={options || []}
          isRequired={isRequired || false}
        />
      );
    case FormQuestionType.TextInput:
      return <TextInput index={index} prompt={prompt || ''} isRequired={isRequired || false} />;
    case FormQuestionType.MultiLineTextInput:
      return <MultiLineTextInput index={index} prompt={prompt || ''} isRequired={isRequired || false} />;
    case FormQuestionType.RatingInput:
      return (
        <Rating
          index={index}
          prompt={prompt || ''}
          minValue={minValue || 0}
          maxValue={maxValue || 5}
          isRequired={isRequired || false}
        />
      );
    case FormQuestionType.DropDown:
      return <DropDown index={index} prompt={prompt || ''} options={options || []} isRequired={isRequired || false} />;
    case FormQuestionType.PetPicker:
      return (
        <DropDown
          index={index}
          prompt={prompt || ''}
          options={['Patient 1', 'Patient 2', 'Patient 3']}
          isRequired={isRequired || false}
        />
      );
    case FormQuestionType.DateInput:
      return <Date index={index} prompt={prompt || ''} isRequired={isRequired || false} />;
    case FormQuestionType.TimeInput:
      return <Time index={index} prompt={prompt || ''} isRequired={isRequired || false} />;
    case FormQuestionType.TextBlock:
      return <TextBlock index={index} prompt={prompt || ''} />;
    case FormQuestionType.SignatureInput:
      return <SignatureInput index={index} prompt={prompt || ''} isRequired={isRequired || false} />;
    default:
      return <></>;
  }
};

export default Question;
